import { useMemo } from 'react';

import { expValEquals } from '@confluence/feature-experiments';
import { usePageContentId, usePageSpaceKey } from '@confluence/page-context';

type MentionRequestModel = {
	contentId?: string;
	spaceId?: string;
	contextType?: string;
	mentionsSessionId?: string;
};

export const useUserSuggestionsMentionsExperiment = (): MentionRequestModel => {
	const [contentId] = usePageContentId(); // objectId
	const [spaceId] = usePageSpaceKey(); // containerId

	const mentionRequestModel = useMemo(() => {
		return {
			contentId,
			spaceId,
			mentionsSessionId: crypto.randomUUID(),
			contextType: 'Mentions',
		};
	}, [contentId, spaceId]);

	if (expValEquals('cc_suggested_users_next', 'cohort', 'variation')) {
		return mentionRequestModel;
	}

	return {
		contentId: undefined,
		spaceId: undefined,
		contextType: undefined,
		mentionsSessionId: undefined,
	};
};
